import React from 'react';

import { SVGComponentProps } from './svg.types';

const VideoSVG = ({ fill = '#878A92', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M10.1816 3.71216H1.96937C0.886214 3.71216 0 4.59837 0 5.68152V12.3183C0 13.4014 0.886214 14.2877 1.96937 14.2877H10.1816C11.2648 14.2877 12.151 13.4014 12.151 12.3183V5.68152C12.151 4.57868 11.2648 3.71216 10.1816 3.71216Z"
        fill={fill}
      />
      <path
        d="M16.5418 4.79539C16.4236 4.81509 16.3054 4.87417 16.207 4.93325L13.1348 6.70568V11.2746L16.2267 13.047C16.7978 13.3818 17.5068 13.1849 17.8415 12.6138C17.94 12.4365 17.9991 12.2396 17.9991 12.023V5.93762C17.9991 5.20896 17.3098 4.61815 16.5418 4.79539Z"
        fill={fill}
      />
    </svg>
  );
};

export default VideoSVG;
